<template>
  <div>
         <Modal
            class-name="ModalResultList"
            :mask-closable="false"
            v-model="resultList.ModalResultList"
            :title="getGameNames.gameNameCHN"
            fullscreen     
            ok-text=""     
            cancel-text="关闭"
             @on-cancel="cloesModalResultList" 
        >
            <div class="resultListMain po-a">
              <div class="po-a groupEventList scrollStyle">
                <div class="groupEventTitle po-a">
                  <div class="addbutton">
                      <Button @click="$emit('groupListShow')" icon="md-add" size="small"   type="info"  >组别</Button>
                      <Button @click="$emit('sexGroupList')" icon="md-add" size="small"  type="info"  >组别性别</Button>
                      <Button @click="$emit('eventListShow')" icon="md-add" size="small"   type="info"  >项目</Button>
                  </div>
                 <div class="ti">
                   
                   <div class="cf userName">
                      <Input class="float-l" @input="searchEventFn" style="width:160px" :maxlength="26" size="small" v-model="searchEvent" placeholder="输入项目名称、组别、赛次"  />
                      <Button class="float-l" type="info"  @click="searchEventFn"  size="small" icon="ios-search" >查询</Button>
                  </div>
                  <h3>赛事列表</h3>
                 </div>
                </div>
                <ul class="groupEventLi">
                  <li
                   class="cf transition"
                   @click="groupEvent(item,index)"
                  v-for="item,index in sexsorteventlayerList"
                  :key="index"
                  :class="{active : index===curId}"
                   >
                    <span class="float-l transition">{{item.sexSortName}}{{item.event}}<span v-if="item.allEvent"> --</span>{{item.allEvent}}<span v-if="item.property!=5">{{item.layerName}}</span></span>
                  </li>
                </ul>
              </div>
              <div class="po-a groupResultList scrollStyle">
                  <div class="ResultList">
                      <div class="groupResultTitle cf">
                        <h3 class="float-l">{{sexsorteventlayerTitle}}</h3>
                        <div  v-if="sexsorteventlayerTitle && getGameNames.gameState===1 ||  !getGameNames.gameState" class="float-r">
                          <Button v-if="propertyType===2&&isResultData" @click="setHeight" icon="md-add" type="info"  >{{$PlugIn.propertyTypeNum(propertyType)}}</Button>
                          <Button v-if="propertyType===4&&isResultData" @click="setRelay" icon="md-add" type="info"  >{{$PlugIn.propertyTypeNum(propertyType)}}</Button>
                          <Button v-if="propertyType===5&&isResultData" @click="setAllRound"  icon="md-add" type="info"  >{{$PlugIn.propertyTypeNum(propertyType)}}</Button>
                          <Button @click="resultFormShowBox({add:true,up:false})" icon="md-add"    type="info"  >成绩录入</Button>
                        </div>
                      </div>
                      
                      <div class="groupResultTable">
                          <div v-if="sexsorteventlayerTitle &&  getGameNames.gameState===1 || getGameNames.gameState===2 ||  !getGameNames.gameState" class="verify">
                            <Button v-if="authorities" size="small" @click="checkboxAll(1)" icon="ios-trash"  type="error"  >批量删除</Button>
                            <Button v-if="authorities" size="small" @click="checkboxAll(2,1)" icon="md-checkbox-outline" class="delData" type="success"  >批量审核</Button>
                            <Button v-if="authorities" size="small" @click="checkboxAll(2,0)" icon="md-checkbox-outline" class="delData" type="error"  >批量取消审核</Button>
                          </div>
                          <div v-if="sexsorteventlayerTitle" class="auditState">
                            审核状态：
                            <Select v-model="selectAuditStateed"  style="width:120px" :label-in-value="true" @on-change="v=>{ selectAuditStateF(v,'type')}" >
                                <Option v-for="item in selectAuditState" :value="item.value" :key="item.value">{{ item.label }}</Option>
                            </Select>
                          </div>
                          <div v-if="sexsorteventlayerTitle">
                  
                              <AllTotalPoints @onDelData="delData"   :wind="wind"  @resultUp="resultUp" :event="event" @trackUpShow="resultFormShowBox" :trackType="trackType" :resultData="resultData"   all-prop="2" v-if="allProp==12||propertyType==5"></AllTotalPoints>
                              <EventTypeTrack @onDelData="delData"   :wind="wind" @trackUpShow="resultFormShowBox" :event="event" :trackType="trackType"  :resultData="resultData" all-prop="1" v-else-if="propertyType==1 || propertyType==6 || propertyType==7 || propertyType==8"></EventTypeTrack>
                              <EventTypeRelay @onDelData="delData"  :wind="wind" @trackUpShow="resultFormShowBox" :excleallProp="excleallProp"   all-prop="1" :resultData="resultData" v-else-if="propertyType==4"></EventTypeRelay>
                              <EventTypeHigh @onDelData="delData"  :wind="wind"  @resultUp="resultUp"  @trackUpShow="resultFormShowBox"  :event="event" :excleallProp="excleallProp"  :resultData="resultData" all-prop="1" v-else-if="propertyType==2 || propertyType==3"></EventTypeHigh>
                          </div>
                          <div v-else class="pointText">请点击左侧赛事列表查看成绩</div>
                      </div>
                  </div>
              </div>
            </div>
        </Modal>
        
        <setHeigth @setHeigthModalShow="setHeigthModalShowF" v-if="propertyType===2" :setHeigthObj="setHeigthObj"></setHeigth>
        <setRelay @setRelayModalShow="setRelayModalShowF" v-if="propertyType===4" :setRelayObj="setRelayObj"></setRelay>
        <setAllRound @setAllRoundModalShow="setAllRoundModalShowF" v-if="propertyType===5" :setAllRoundObj="setAllRoundObj"></setAllRound>
  </div>
</template>

<script>
import {scoreAudit,sexsorteventlayer,getGrade,getsexSortEvent,delAllEvent,delArEvent,delHighEvent,delRelayEvent,delRunEvent,delBatchAllEvent,delBatchArEvent,delBatchHighEven,delBatchRelayEven,delBatchRunEven} from '@/lib/api/index.js'
import EventTypeTrack from './EventTypeTrack.vue'
import EventTypeHigh from './EventTypeHigh';
import EventTypeRelay from './EventTypeRelay';
import AllTotalPoints from './AllTotalPoints';
import setHeigth from './setHeigth';
import setRelay from './setRelay';
import setAllRound from './setAllRound';

let requiredStr = '必选项不能为空！'
export default {
  props: ['setting','gameId','resultList','eventList','sexGroup','resultListData'],
  components: {
    EventTypeTrack,
    EventTypeHigh,
    EventTypeRelay,
    AllTotalPoints,
    setHeigth,
    setRelay,
    setAllRound
  },

  data(){
    return {
      // 成绩录入
      sexType:0,
      isResultData:true,//判断是否有手工录入的成绩数据
      ressultFilter:[],//审核筛选的数据源
      searchEvent:'',
      layerName:'',
      curId:'',
      wind:'',
      selectAuditStateed:2,
      selectAuditState:[
        {
          label:'全部',
          value:2,
        },
        {
          label:'已审核',
          value:1,
        },
        {
          label:'未审核',
          value:0,
        },
      ],
      setHeigthObj:{
        setHeigthModal:false,
        layer:'',
        sexSortEventID:'',
        gameId:''
      },
      setRelayObj:{
        setRelayModal:false,
        gameId:'',
        event:'',
      },
      setAllRoundObj:{
        setAllRoundModal:false,
        sexsorteventID:''
      },
      sexsorteventlayerList:[],
      searchsexsorteventlayerList:[],
      sexsorteventlayerTitle:'',
      propertyType:'',
      allProp:'',
      resultData:[],
      excleallProp:'',
      trackType:'',
      event:'',
      sexSortEventLayerID:'',
      sexSortEventID:''
    }
  },
  watch: {
    modalResultList()
    {
      if(this.resultList.ModalResultList)
      {
        this.getsexsorteventlayer();
      }
    },
    resultListUp()
    {
      this.getsexsorteventlayer();
    },
    getresultListData()
    {
      this.groupEvent(this.sexsorteventlayerList[this.curId],this.curId,true);
    },
    sexsorteventlayerLists()
    {
      
      this.sexsorteventlayerList = this.$store.state.grade.sexsorteventlayerList;
      this.searchsexsorteventlayerList = this.$store.state.grade.sexsorteventlayerList;
    }
    
  },
  computed:{
    getGameNames(){
      return this.$store.state.unitAllData.gameName
    },
    sexsorteventlayerLists(){
      return this.$store.state.grade.sexsorteventlayerList
    },
    modalResultList(){
      return this.resultList.ModalResultList
    },
    resultListUp()
    {
      return this.eventList.ModalEvent;
    },
    getresultListData()
    {
      return this.resultListData;
    },
    getResult(){
      return this.$store.state.unitAllData.result
    },
    authorities()
    {
      return JSON.parse(localStorage.authorities)==this.$PlugIn.role.admin||JSON.parse(localStorage.authorities)==this.$PlugIn.role.entryAdmin;
    },
  },
  methods:{
    setRelayModalShowF(){
      this.setRelayObj.setRelayModal =false;
    },
    setHeigthModalShowF()
    {
      this.setHeigthObj.setHeigthModal =false;
    },
    setAllRoundModalShowF()
    {
      this.setAllRoundObj.setAllRoundModal = false;
    },
    selectAuditStateF(obj)
    {
      
      if(obj.value===2)
      {
          this.resultData.data = this.ressultFilter;
      }else{
        let list = this.ressultFilter.filter((item)=>{
            if(obj.value===1)
            {
              return 1===item.auditState;
            }else{
              return 0===item.auditState;
            }
        });
        this.resultData.data = list;
      }
   
       
    },
    delThen(res)
    {
       if(res.data.code == 0){
            this.$Message.info("删除成功");
            this.groupEvent(this.sexsorteventlayerList[this.curId],this.curId,true);
        }else if(res.data.code == -2){
            this.$Message.error("删除失败");
        }else if(res.data.code==10)
        {
            this.$Message.info("登录token过期请重新登录");
            this.$store.dispatch('loginOut');
        }else{
            this.$Message.error(res.data.msg); 
            
        }
    },
    scoreAuditF(res,type)
    {
        if(res.data.code == 0){
            if(type==2)
            {
              this.$Message.info("成功通过审核");
            }else if(type==4)
            {
              this.$Message.info("不通过审核");
            }else{
              this.$Message.info("成功取消审核");
            }
            this.groupEvent(this.sexsorteventlayerList[this.curId],this.curId,true);
        }else if(res.data.code == -2){
            this.$Message.error("网络连接失败");
        }else if(res.data.code==10)
        {
            this.$Message.info("登录token过期请重新登录");
            this.$store.dispatch('loginOut');
        }else{
            this.$Message.error(res.data.msg);
            
        }
    },
    delAllData(id)
    {
      if(this.getResult.property === 5)
      {
          delBatchAllEvent(id).then(res => {
              this.delThen(res);
          },err =>{
              this.$Message.error("网络连接失败");
          });
      }else if(this.getResult.property === 4)
      {
        delBatchRelayEven(id).then(res => {
          this.delThen(res);
        },err =>{
            this.$Message.error("网络连接失败");
        });
      }else if(this.getResult.property === 3)
      {
        delBatchArEvent(id).then(res => {
            this.delThen(res);
        },err =>{
            this.$Message.error("网络连接失败");
        });
      }else if(this.getResult.property === 2)
      {
        delBatchHighEven(id).then(res => {
          this.delThen(res);
        },err =>{
            this.$Message.error("网络连接失败");
        });
      }else
      {
        delBatchRunEven(id).then(res => {
          this.delThen(res);
        },err =>{
            this.$Message.error("网络连接失败");
        });
      }
    },
    delAllBut(id)
    {
      this.$Modal.confirm({
        title: '你确认要删除吗？',
        onOk: () => {
          this.delAllData(id);
        },
      });
    },
    verifyBut(data)
    {
        let auditState = data[0].auditState?2:3;
        let str = auditState===2?'通过审核':'取消审核';
        this.$Modal.confirm({
          title: '你确认要'+str+'吗？',
          onOk: () => {
            scoreAudit(data).then(res => {
              this.scoreAuditF(res,auditState);
            },err =>{
                this.$Message.error("网络连接失败");
            });
          },
        });
    },
    delData(obj)
    {
        // this.propertyType === 5
        if(this.getResult.property === 5)
        {
          if(obj.types==2)
          {
             let allEvent1 = [{
              property:this.getResult.property,
              id:obj.allEventScoreID,
              auditState:1
             }]
            scoreAudit(allEvent1).then(res => {
              this.scoreAuditF(res,obj.types);
            },err =>{
                this.$Message.error("网络连接失败");
            });
          }else if(obj.types==3)
          {
            let allEvent2 = [{
              property:this.getResult.property,
              id:obj.allEventScoreID,
              auditState:0
             }]
            scoreAudit(allEvent2).then(res => {
              this.scoreAuditF(res,obj.types);
            },err =>{
                this.$Message.error("网络连接失败");
            });
          }else if(obj.types==4)
          {
            let allEvent2 = [{
              property:this.getResult.property,
              id:obj.allEventScoreID,
              auditState:-1,
              auditUnPassReason:obj.auditUnPassReason
             }]
            scoreAudit(allEvent2).then(res => {
              this.scoreAuditF(res,obj.types);
            },err =>{
                this.$Message.error("网络连接失败");
            });
          }else
          {
            delAllEvent(obj.allEventScoreID).then(res => {
              this.delThen(res);
            },err =>{
                this.$Message.error("网络连接失败");
            });
          }
            
        }else if(this.getResult.property === 4)
        {
           if(obj.types==2)
          {
             let relayEvent1 = [{
              property:this.getResult.property,
              id:obj.relayEventID,
              auditState:1
             }]
            scoreAudit(relayEvent1).then(res => {
              this.scoreAuditF(res,obj.types);
            },err =>{
                this.$Message.error("网络连接失败");
            });
          }else if(obj.types==3)
          {
            let relayEvent2 = [{
              property:this.getResult.property,
              id:obj.relayEventID,
              auditState:0
             }]
            scoreAudit(relayEvent2).then(res => {
              this.scoreAuditF(res,obj.types);
            },err =>{
                this.$Message.error("网络连接失败");
            });
          }else if(obj.types==4)
          {
            let relayEvent2 = [{
              property:this.getResult.property,
              id:obj.relayEventID,
              auditState:-1,
              auditUnPassReason:obj.auditUnPassReason
             }]
            scoreAudit(relayEvent2).then(res => {
              this.scoreAuditF(res,obj.types);
            },err =>{
                this.$Message.error("网络连接失败");
            });
          }else{
            delRelayEvent(obj.relayEventID).then(res => {
              this.delThen(res);
            },err =>{
                this.$Message.error("网络连接失败");
            });
          }
        }else if(this.getResult.property === 3)
        {

          if(obj.types==2)
          {
             let farEvent1 = [{
              property:this.getResult.property,
              id:obj.farEventBestID,
              auditState:1
             }]
             
            scoreAudit(farEvent1).then(res => {
              this.scoreAuditF(res,obj.types);
            },err =>{
                this.$Message.error("网络连接失败");
            });
          }else if(obj.types==3)
          {
            let farEvent2 = [{
              property:this.getResult.property,
              id:obj.farEventBestID,
              auditState:0
             }]
            scoreAudit(farEvent2).then(res => {
              this.scoreAuditF(res,obj.types);
            },err =>{
                this.$Message.error("网络连接失败");
            });
          }else if(obj.types==4)
          {
            let farEvent2 = [{
              property:this.getResult.property,
              id:obj.farEventBestID,
              auditState:-1,
              auditUnPassReason:obj.auditUnPassReason
             }]
            scoreAudit(farEvent2).then(res => {
              this.scoreAuditF(res,obj.types);
            },err =>{
                this.$Message.error("网络连接失败");
            });
          }else{
            delArEvent(obj.farEventBestID).then(res => {
              this.delThen(res);
            },err =>{
                this.$Message.error("网络连接失败");
            });
          }
         
        }else if(this.getResult.property === 2)
        {
          if(obj.types==2)
          {
             let highEvent1 = [{
              property:this.getResult.property,
              id:obj.highEventBestID,
              auditState:1
             }]
            scoreAudit(highEvent1).then(res => {
              this.scoreAuditF(res,obj.types);
            },err =>{
                this.$Message.error("网络连接失败");
            });
          }else if(obj.types==3)
          {
            let highEvent2 = [{
              property:this.getResult.property,
              id:obj.highEventBestID,
              auditState:0
             }]
            scoreAudit(highEvent2).then(res => {
              this.scoreAuditF(res,obj.types);
            },err =>{
                this.$Message.error("网络连接失败");
            });
          }else if(obj.types==4)
          {
            let highEvent2 = [{
              property:this.getResult.property,
              id:obj.highEventBestID,
              auditState:-1,
              auditUnPassReason:obj.auditUnPassReason
             }]
            scoreAudit(highEvent2).then(res => {
              this.scoreAuditF(res,obj.types);
            },err =>{
                this.$Message.error("网络连接失败");
            });
          }else{
            delHighEvent(obj.highEventBestID).then(res => {
              this.delThen(res);
            },err =>{
                this.$Message.error("网络连接失败");
            });
          }
        }else
        {
          if(obj.types==2)
          {
             let runEvent1 = [{
              property:this.getResult.property,
              id:obj.runEventID,
              auditState:1
             }]
            scoreAudit(runEvent1).then(res => {
              this.scoreAuditF(res,obj.types);
            },err =>{
                this.$Message.error("网络连接失败");
            });
          }else if(obj.types==3)
          {
            let runEvent2 = [{
              property:this.getResult.property,
              id:obj.runEventID,
              auditState:0
             }]
            scoreAudit(runEvent2).then(res => {
              this.scoreAuditF(res,obj.types);
            },err =>{
                this.$Message.error("网络连接失败");
            });
          }else if(obj.types==4)
          {
            let runEvent2 = [{
              property:this.getResult.property,
              id:obj.runEventID,
              auditState:-1,
              auditUnPassReason:obj.auditUnPassReason
             }]
            scoreAudit(runEvent2).then(res => {
              this.scoreAuditF(res,obj.types);
            },err =>{
                this.$Message.error("网络连接失败");
            });
          }else{
            delRunEvent(obj.runEventID).then(res => {
              this.delThen(res);
            },err =>{
                this.$Message.error("网络连接失败");
            });
          }
        }
     
      
    },
    resultUp()
    {
      this.getresultListData;
    },
    checkboxAll(now,auditState)
    {
          let verify = document.getElementsByName('verify');
          let num = [];
          if(this.resultData.data)
          {
            for(let i = 0; i<verify.length;i++)
            {
                if(verify[i].checked)
                {
                  if(now===1)
                  {
                    // this.propertyType
                    switch(this.getResult.property)
                    {
                      case 2:
                        num.push(this.resultData.data[i].highEventBestID); 
                        break;
                      case 3:
                        num.push(this.resultData.data[i].farEventBestID); 
                        break;
                      case 4:
                        num.push(this.resultData.data[i].relayEventID); 
                        break;
                      case 5:
                        num.push(this.resultData.data[i].allEventScoreID);
                        break;
                      default:
                        num.push(this.resultData.data[i].runEventID) 
                    }
                  }else{
                    switch(this.getResult.property)
                    {
                      case 2:
                        num.push({
                          id: this.resultData.data[i].highEventBestID,
                          property:this.getResult.property,
                          auditState:auditState
                        }); 
                        break;
                      case 3:
                        num.push({
                          id: this.resultData.data[i].farEventBestID,
                          property:this.getResult.property,
                          auditState:auditState
                        }); 
                        break;
                      case 4:
                        num.push({
                          id: this.resultData.data[i].relayEventID,
                          property:this.getResult.property,
                          auditState:auditState
                        }); 
                        break;
                      case 5:
                        num.push({
                          id: this.resultData.data[i].allEventScoreID,
                          property:this.getResult.property,
                          auditState:auditState
                        }); 
                        break;
                      default:
                        num.push({
                          id: this.resultData.data[i].runEventID,
                          property:this.getResult.property,
                          auditState:auditState
                        }); 
                    }
                  }
                  
                  
                }


            }
            if(num.length)
            {
               if(now===2)
               {
                 this.verifyBut(num);
               }else{
                 this.delAllBut(num);
               }
            }else{
              this.$Message.info("最少要选择一条数据");
            }
          }else{
            this.$Message.info("最少要选择一条数据");
          }
    },
    setHeight()
    {
      this.setHeigthObj.setHeigthModal = true;
    },
    setRelay()
    {
      this.setRelayObj.setRelayModal = true;
      this.setRelayObj.gameId = this.gameId;
    },
    setAllRound()
    {
           this.setAllRoundObj.setAllRoundModal =true;
    },
    isRessultFilter(arr)//筛选是否有手工录入成绩数据，控制显示设置成绩参数
    {
      if(arr.length)
      {
        for(let i = 0; i<arr.length;i++)
        {
            if(arr[i].scoreEntryId)
            {
              this.isResultData = false;
              break;
            }else{
              this.isResultData = true;
            }
        }
      }else
      {
        this.isResultData = true;
      }
      
    },
    groupEvent(item,index,now)
    {
      let verify = document.getElementsByName('verify');
      let checkAll = document.getElementById('checkAll');
      this.wind = item.wind;
      for(let i = 0; i<verify.length;i++)
      {
          verify[i].checked = false;
      }
      if(checkAll)
      {
        checkAll.checked = false;
      }
      
      if(this.curId != index || this.curId==='' || now)
      {
          this.selectAuditStateed = 2;
          this.sexType = item.sex;
          this.curId = index;
          this.excleallProp = item.allProp === undefined ? 'excle' : item.allProp;
          this.sexSortEventLayerID = item.sexSortEventLayerID;
          this.sexSortEventID = item.sexSortEventID;
          this.setHeigthObj.sexSortEventID = item.sexSortEventID;
          this.setHeigthObj.layer = item.layer;
          this.setRelayObj.event = item.event;
          this.setAllRoundObj.sexsorteventID = item.sexSortEventID;
          let Parameter = {
              property: item.property ? item.property : 5,
              sexSortEventID: item.sexSortEventID,
              layer: item.layer,
              allProp: item.allProp === undefined ? item.property===5 ? 1 : 0 : item.allProp,
          }
          this.event = item.event;
          if((item.property===5 && item.allProp === undefined) ||  item.property==undefined)
          {
              getsexSortEvent(item.sexSortEventID).then( (res) => {
                if(res.data.code==0)
                {
                  this.sexsorteventlayerTitle = item.sexSortName+item.event
                  this.propertyType = 5;
                  this.allProp = 12;
                  this.resultData = res.data;
                  this.resultData.data = this.resultData.data?this.resultData.data:[];
                  this.ressultFilter = this.$PlugIn.deepClone(this.resultData.data);
                  this.trackType = item.trackType;
                  this.isRessultFilter(this.ressultFilter);
                  this.$store.dispatch("paragraphResult", item);
                }else if(res.data.code == -2){
                    this.$Message.error("获取失败");
                    this.$Spin.hide();
                }else if(res.data.code==10)
                {
                    this.$Message.info("登录token过期请重新登录");
                    this.$store.dispatch('loginOut');
                }else{
                    this.$Message.error(res.data.msg);
                    this.$Spin.hide();
                }
              
              }).catch((error) => {
              })
          }else{
            //请求成绩数据
            getGrade(Parameter).then( (res) => {
                if(res.data.code==0)
                {
                  let layerName = item.property === 5 ? '之'+item.allEvent : '-'+item.layerName;
                  this.sexsorteventlayerTitle = item.sexSortName+item.event+layerName;
                  this.propertyType = item.property;
                  this.allProp = item.allProp;
                  this.resultData = res.data;
                  this.resultData.data = this.resultData.data?this.resultData.data:[];
                  this.ressultFilter = this.$PlugIn.deepClone(this.resultData.data);
                  this.trackType = item.trackType;
                  this.$store.dispatch("paragraphResult", item);
                  
                  this.isRessultFilter(this.ressultFilter);
                }else if(res.data.code == -2){
                    this.$Message.error("获取失败");
                }else if(res.data.code==10)
                {
                    this.$Message.info("登录token过期请重新登录");
                    this.$store.dispatch('loginOut');
                }else{
                    this.$Message.error(res.data.msg);
                }
            }).catch((error) => {
            })
          }
     
      }
    },
    resultFormShowBox(obj)
    {
      if(obj.add!==true)
      {
        obj.data.imageUrl = obj.data.imageUrl ? obj.data.imageUrl : '';
        obj.sexType = this.sexType;
        this.$emit('resultFormShow',obj);
      }else{
        this.$emit('resultFormShow',{
          sexSortEventID:this.sexSortEventID,
          sexSortEventLayerID:this.sexSortEventLayerID,
          layer: this.setHeigthObj.layer,
          event: this.setRelayObj.event,
          imageUrl:"",
          addData:true,
          sexType: this.sexType,
          up:obj.up
        });
      }
      return false;
    },
    cloesModalResultList()
    {
      this.sexsorteventlayerTitle = '';
      this.curId = '';
      this.searchEvent = '';
    },
    searchEventFn()
    {
      this.sexsorteventlayerList = this.searchsexsorteventlayerList.filter(item=>{
          let str = item.sexSortName+item.event+item.allEvent+item.layerName;
          if(this.searchEvent==='')
          {
            return true;
          }else{
            return str.indexOf(this.searchEvent)!==-1;
          }
          
      })
    },
    getsexsorteventlayer()
    {
      sexsorteventlayer(this.getGameNames.gameID).then(res => {
          if(res.data.code == 0){
            if(res.data.data.length)
            {
              // this.sexsorteventlayerList = res.data.data[0].list;
              // this.searchsexsorteventlayerList  = res.data.data[0].list;
              this.sexsorteventlayerList = res.data.data;
              this.searchsexsorteventlayerList  = res.data.data;
            }else{
              this.sexsorteventlayerList = [];
              this.searchsexsorteventlayerList  = []
            }
          }else if(res.data.code == -2){
              this.$Message.error("获取失败");
          }else if(res.data.code==10)
          {
              this.$Message.info("登录token过期请重新登录");
              this.$store.dispatch('loginOut');
          }else{
              this.$Message.error(res.data.msg);
          }
      },err =>{
          this.$Message.error("网络连接失败");
      });
    }
    
  },
  created(){},
  mounted(){
    this.getsexsorteventlayer();
  }
     
}

</script>

<style scoped >
  .resultListMain{bottom:0;top:0;width:98%;}
  .groupEventList{height:100%;width: 256px;background: #f0f0f0;border-right: 1px solid #ddd; overflow-y: auto;left: 0;z-index: 2;}
  .groupResultList{height:100%; overflow-y: auto;left: 0;z-index: 1;right: 0;}
  .ResultList{padding-left: 272px;}
  .groupEventLi li{line-height: 24px;padding: 4px 8px;border-bottom: 1px solid #f9f9f9;}
  .groupEventLi li:nth-of-type(odd){background: #eee;}
  .groupEventLi li span.float-l{color:#30a5ff;max-width:220px;cursor: pointer;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
  .groupEventLi li:hover,.groupEventLi li.active{background: #fff;position: relative;}
  .groupEventLi li.active:before{height: 100%;width:2px;position: absolute;right:0;top:0;background:#30a5ff;content:''}
  .groupEventLi li:hover span,.groupEventLi li.active span{font-weight: bold;}
  .groupEventLi {padding-top: 136px;}
  .groupEventTitle{border-bottom:1px solid #ccc;padding: 12px 0px;width:100%;}
  .groupEventTitle .ivu-form-item{margin-bottom: 12px;}
  .groupResultTitle{border-bottom: 1px solid #ccc;line-height: 32px;padding: 12px 0;min-height: 32px;}
  .addbutton{border-bottom: 1px solid #ccc;padding-bottom: 12px;padding-left: 8px;}
  .groupEventTitle .ti{padding-left: 8px;padding-top: 12px;}
  .pointText{font-size: 18px;color: #ccc;margin-top: 96px;text-align: center;border: 1px solid #ddd;padding: 32px 0;}
  .groupEventTitle .userName{padding-bottom: 8px;}
  .auditState{padding-top: 22px;}
</style>


// WEBPACK FOOTER //
// src/components/resultList.vue